import { useState, Dispatch, SetStateAction } from 'react';
import { IMetric } from 'maps/metrics';

export default useSorting;

function useSorting(
  initialSortMetric: IMetric | undefined | any,
  initialSortOrder = 'desc'
): {
  sortOrder: string;
  setSortOrder: Dispatch<SetStateAction<string>>;
  sortMetric: IMetric | undefined;
  setSortMetric: Dispatch<SetStateAction<IMetric | undefined>>;
  switchSortOrder: () => void;
  changeSortMetric: (metric: IMetric) => void;
} {
  const [sortOrder, setSortOrder] = useState(initialSortOrder);
  const [sortMetric, setSortMetric] = useState(initialSortMetric);

  function switchSortOrder(): void {
    setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
  }

  function changeSortMetric(metric: IMetric): void {
    if (
      sortMetric?.value === metric?.value &&
      sortMetric?.label === metric?.label
    ) {
      return switchSortOrder();
    }

    setSortMetric(metric);
    setSortOrder(
      metric?.sortOrder || (metric?.value === 'displayName' ? 'asc' : 'desc')
    );
  }

  return {
    sortOrder,
    setSortOrder,
    sortMetric,
    setSortMetric,
    switchSortOrder,
    changeSortMetric,
  };
}
